import { render, staticRenderFns } from "./EventFormOnline.vue?vue&type=template&id=31b1f033"
import script from "./EventFormOnline.vue?vue&type=script&lang=js"
export * from "./EventFormOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports